import Vue, { DirectiveOptions } from 'vue';
import Waiting from './Waiting.vue';

interface HTMLElementWithLoading extends HTMLElement {
  __loading?: Vue;
  __loadingDom?: HTMLDivElement;
}

const LoadingComponent = Vue.extend(Waiting);

declare module 'vue/types/vue' {
  interface Vue {
    isLoading: string;
    statement: string;
  }
}

const retry = function () {
  window.location.reload();
};

const loading: DirectiveOptions = {
  bind(el: HTMLElementWithLoading, binding) {
    const modifiers = binding.modifiers;

    el.__loading = new LoadingComponent({
      propsData: {
        isLoading: binding.value.isLoading,
        center: !!modifiers.center,
        transparent: !!modifiers.transparent,
        full: !!modifiers.full,
        statement: binding.value.statement,
      },
    });
    el.__loadingDom = document.createElement('div');
  },

  inserted(el: HTMLElementWithLoading) {
    const __loading = el.__loading;
    const __loadingDom = el.__loadingDom;

    const retryFun = retry;
    const elPos = window.getComputedStyle(el);
    const { position } = elPos;

    if (position !== 'fixed' && position !== 'absolute' && position !== 'relative') {
      el.style.position = 'relative';
    }

    if (__loading && __loadingDom) {
      el.appendChild(__loadingDom);
      __loading.$mount(__loadingDom);
      __loading.$on('fail', retryFun);
    }
  },

  componentUpdated(el: HTMLElementWithLoading, binding) {
    const __loading = el.__loading;
    if (__loading) {
      __loading.isLoading = binding.value.isLoading;
      __loading.statement = binding.value.statement;
    }
  },

  unbind(el: HTMLElementWithLoading) {
    if (el.__loading) {
      el.__loading.$destroy();
      delete el.__loading;
      delete el.__loadingDom;
    }
  },
};

export default loading;
